import { FormBuilder, Validators } from '@angular/forms';
import { getNgbDateFromDate } from '../helpers/date-picket';
import { IMilestoneResponseDto } from '../models/responses/milestone.response';

export const addMilestoneForm = () =>
    FormBuilder.prototype.group({
        milestones: FormBuilder.prototype.array([])
    });

export const milestoneFormControls = (defaultMilestone: IMilestoneResponseDto) =>
    FormBuilder.prototype.group({
        description: [{value: defaultMilestone?.description,disabled: defaultMilestone },  [Validators.required, Validators.maxLength(50)]],
        amount: [{value: defaultMilestone?.amount,disabled: defaultMilestone },  [Validators.required]],
        startDate: [{value: getNgbDateFromDate(defaultMilestone?.startDate),disabled: defaultMilestone },  [Validators.required]],
        endDate: [{value: getNgbDateFromDate(defaultMilestone?.endDate), disabled: defaultMilestone }, [Validators.required]],
    });

export const milestoneValidationMessages = {
  description: {
    required: 'Description is required.',
    maxLength: 'Description must not exceed 50 characters.'
  },
  amount: {
    required: 'Amount is required.',
  },
  startDate: {
    required: 'Start date is required.',
  },
  endDate: {
    required: 'End date is required.'
  }
}
